import { render, staticRenderFns } from "./Abnormal.vue?vue&type=template&id=1271ae1c&scoped=true&"
import script from "./Abnormal.vue?vue&type=script&lang=js&"
export * from "./Abnormal.vue?vue&type=script&lang=js&"
import style0 from "./Abnormal.vue?vue&type=style&index=0&id=1271ae1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271ae1c",
  null
  
)

export default component.exports